(function(api) {

	api.GetDokumentiFields = GetDokumentiFields;
	api.GetDokumentiTemplateFields = GetDokumentiTemplateFields;
	api.GetDokPotpisSFields = GetDokPotpisSFields;
	api.DokPotpisSObrisi = DokPotpisSObrisi;
	api.DokPotpisObrisi = DokPotpisObrisi;
	api.DokPotpisArhiviraj = DokPotpisArhiviraj;
	api.UpisiHodogramUDigitalnu = UpisiHodogramUDigitalnu;
	api.DokPotpisSPonisti = DokPotpisSPonisti;
	api.DokumentObrisi = DokumentObrisi;
	api.UstrojById = UstrojById;
	api.PreuzmiPredmet = PreuzmiPredmet;
	api.ObradiSurjesavanje = ObradiSurjesavanje;
	api.ObradiSurjesavanjePismena = ObradiSurjesavanjePismena;
	api.ObradiParaf = ObradiParaf;
	api.GetUstrojZaPartnera = GetUstrojZaPartnera;
	api.PismenaZaPredmetFields = PismenaZaPredmetFields;
	api.PredmetTZaPredmetFields = PredmetTZaPredmetFields;
	api.DatotekePismenaPredmetaFields = DatotekePismenaPredmetaFields;
	api.PriloziZaPredmetFields = PriloziZaPredmetFields;
	api.GetPismenoTemplate = GetPismenoTemplate;
	api.PismenoObrisi = PismenoObrisi;
	api.PonistiSlanjePismena = PonistiSlanjePismena;
	api.PreuzmiPismeno = PreuzmiPismeno;
	api.PredmetObrisi = PredmetObrisi;
	api.GetSljedeciBrojPismena = GetSljedeciBrojPismena;
	api.PredmetById = PredmetById;
	api.GetDostavnicaSFields = GetDostavnicaSFields;
	api.FormirajDostavnicuZaDostavnicuS = FormirajDostavnicuZaDostavnicuS;
	api.SetBrojKuverte = SetBrojKuverte;
	api.DostavnicaObrisi = DostavnicaObrisi;
	api.DostavnicaUOtpremu = DostavnicaUOtpremu;
	api.DostavniceSObrisi = DostavniceSObrisi;
	api.DatotekeZaDokumentFields = DatotekeZaDokumentFields;
	api.DodajPostojecuDatoteku = DodajPostojecuDatoteku;
	api.DokDatObrisi = DokDatObrisi;
	api.DatotekaObrisi = DatotekaObrisi;
	api.PonistiSlanjePredmeta = PonistiSlanjePredmeta;
	api.PismenaKojaSeSalju = PismenaKojaSeSalju;
	api.PismenaNaDrugomDokumMj = PismenaNaDrugomDokumMj; // i koja nisu kod nas a u slanju su nekamo
	api.DokPotShsZaIspravak = DokPotShsZaIspravak;
	api.DokumentObrisiVezu = DokumentObrisiVezu;
	api.DokumentUpisiVezu = DokumentUpisiVezu;
	api.ObrisiVezuDostavnicaSNaDokument = ObrisiVezuDostavnicaSNaDokument;
	api.GetKlasaPlanInfo = GetKlasaPlanInfo;
	api.PismenoNovo = PismenoNovo;
	api.KlasaPlanByOznaka = KlasaPlanByOznaka;
	api.DokumentById = DokumentById;
	api.GetDokumentPravoNa = GetDokumentPravoNa;
	api.GetDokDatZakljucanDo = GetDokDatZakljucanDo;
	api.DGrupaById = DGrupaById;
	api.KlasaPlanById = KlasaPlanById;
	api.ZUpravneStvariById = ZUpravneStvariById;
	api.NadleznostDeaktiviraj = NadleznostDeaktiviraj;
	api.NadleznostEmailOIntDostavi = NadleznostEmailOIntDostavi;
	api.GetUrBrojZaPodnesak = GetUrBrojZaPodnesak;
	api.GetUrBrojZaAkt = GetUrBrojZaAkt;
	api.ProvjeriDokumentDuplo = ProvjeriDokumentDuplo;
	api.GetDatotekaNaziv = GetDatotekaNaziv;
	api.GetDatotekeDokumentaLista = GetDatotekeDokumentaLista;
	api.DodajNovuDatoteku = DodajNovuDatoteku;
	api.DatotekaRename = DatotekaRename;
	api.VrstaPismenaObrisi = VrstaPismenaObrisi;
	api.PismenoObradiBarkod = PismenoObradiBarkod;
	api.SetDostavnicaSDatumPovratnice = SetDostavnicaSDatumPovratnice;
	api.VrDostavePosiljkaSPovratnicom = VrDostavePosiljkaSPovratnicom;
	api.VrDostaveRazlogNeotvaranja = VrDostaveRazlogNeotvaranja;
	api.BrojDatotekaZaDokument = BrojDatotekaZaDokument;
	api.DokumentObrisiVezuIDokument = DokumentObrisiVezuIDokument;
	api.GetPravoNaDokument = GetPravoNaDokument;
	api.PostaviDokDatZadan = PostaviDokDatZadan;
	api.PostaviPotpisUDatoteci = PostaviPotpisUDatoteci;
	api.PostaviDokDatPonisteno = PostaviDokDatPonisteno;
	api.PredmetJeBioUSlanju = PredmetJeBioUSlanju; //ili je još uvijek
	api.PosaljiMailZaPotpis = PosaljiMailZaPotpis;
	api.DokumentMakniSNepovezanih = DokumentMakniSNepovezanih;
	api.DokumentImaVezuNaSamogSebe = DokumentImaVezuNaSamogSebe;
	api.DohvatiDatotekuBase64 = DohvatiDatotekuBase64;
	api.DohvatiDatotekuZaPotpisUZ = DohvatiDatotekuZaPotpisUZ;
	api.DohvatiIPotpisiDatotekuSoft = DohvatiIPotpisiDatotekuSoft;
	api.GetPravoNaDokument = GetPravoNaDokument;
	api.DohvatiDokPotShZaDGrupaKlasaPlan = DohvatiDokPotShZaDGrupaKlasaPlan;
	api.GenPotpisnikePremaShemi = GenPotpisnikePremaShemi;
	api.DajSveGrupeKorZaUz = DajSveGrupeKorZaUz;
	api.DeaktivirajDGrupaKor = DeaktivirajDGrupaKor;
	api.DajPopisDGrupa = DajPopisDGrupa;
	api.DajPopisKorisnikaIliGrupa = DajPopisKorisnikaIliGrupa;
	api.DajTextLabeleZaSkupnoPotpisivanje = DajTextLabeleZaSkupnoPotpisivanje;
	api.ZadnjiPotpisJeSaCert = ZadnjiPotpisJeSaCert;
	api.GetDokPotShSFields = GetDokPotShSFields;
	api.DokPotpisById = DokPotpisById;
	api.DajDokPotpisZaDokument = DajDokPotpisZaDokument;
	api.PredmetInfo = PredmetInfo;
	api.PismenoInfo = PismenoInfo;
	api.DokumentInfo = DokumentInfo;
	api.UpisiDokumentUVanjskuPisarnicu = UpisiDokumentUVanjskuPisarnicu;
	api.DokumentMoguceBrisanje = DokumentMoguceBrisanje;
	api.DokumentObradiBarkod = DokumentObradiBarkod;
	api.PostaviDokumentStatus = PostaviDokumentStatus;
	api.PostaviDokumentERacunStatus = PostaviDokumentERacunStatus;
	api.ProvjeriDokumentZaIspravak = ProvjeriDokumentZaIspravak;
	api.DozvoliPrikazDatotekeSCert = DozvoliPrikazDatotekeSCert;
	api.DohvatiDatotekuIdPrvuZadnju = DohvatiDatotekuIdPrvuZadnju;
	api.GetSveDokPotSh = GetSveDokPotSh;
	api.VrNamjenaObrisi = VrNamjenaObrisi;
	api.DostavnicaSObrisi = DostavnicaSObrisi;
	api.DostavnicaSRenumerirajStavke = DostavnicaSRenumerirajStavke;
	api.DatotekuPovratniceDodatiUAkt = DatotekuPovratniceDodatiUAkt;
	api.DostavnicaSRenumerirajKuvertu = DostavnicaSRenumerirajKuvertu;
	api.DodajUPostojecuDostavnicu = DodajUPostojecuDostavnicu;
	api.AzurirajDatotekeZaDokument = AzurirajDatotekeZaDokument;
	api.PostojiHodogramZaDokument = PostojiHodogramZaDokument;
	api.PostojePotpisniciZaDokument = PostojePotpisniciZaDokument;
	api.SluzbenaZaPredmetFields = SluzbenaZaPredmetFields;
	api.SluzbenaObrisi = SluzbenaObrisi;
	api.UstrojParObrisi = UstrojParObrisi;
	api.DostavnicaSGenerirajPismeno = DostavnicaSGenerirajPismeno;
	api.DostavnicaSEmailInfo = DostavnicaSEmailInfo;
	api.GetPredmetParLista = GetPredmetParLista;
	api.GetPredmetParFields = GetPredmetParFields;
	api.PartnerUzById = PartnerUzById;
	api.ZPostupakArhZaPredmetFields = ZPostupakArhZaPredmetFields;
    api.ZupItPosaljiPredmet = ZupItPosaljiPredmet;
    api.ZupItDohvatiJavnopravnaTijela = ZupItDohvatiJavnopravnaTijela;    
    api.ZupItDohvatiUpravneStvari = ZupItDohvatiUpravneStvari;
    api.ZupItDohvatiStatuse = ZupItDohvatiStatuse;    
    api.PrKnjigaById = PrKnjigaById;
    api.PregledOcr = PregledOcr;    
    api.PrepoznajOcr = PrepoznajOcr;
    api.PonistiOznakuZaOCR = PonistiOznakuZaOCR;
    api.ZOsobaZupItNoviKorisnikLozinka = ZOsobaZupItNoviKorisnikLozinka;    
	api.PotpisiCertilia = PotpisiCertilia;    
	api.GetPrilozi = GetPrilozi;    
    
	function GetPrilozi(pismeno) {
		return $.dsDirectCall({
            method: "GetPrilozi",
            params: [pismeno]
        });
	}


	function PotpisiCertilia(dokDat, dokPotpisS, mobilniPotpis) {
		return $.dsDirectCall({
            method: "PotpisiCertilia",
            params: [dokDat, dokPotpisS, mobilniPotpis]
        });
	}

	function GetDokPotShSFields(dokPotpis) {
		return $.dsDirectCall({
            method: "GetDokPotShSFields",
            params: [dokPotpis]
        });
	}

	function ZadnjiPotpisJeSaCert(dokPotpis) {
		return $.dsDirectCall({
            method: "ZadnjiPotpisJeSaCert",
            params: [dokPotpis]
        });
	}

	function DohvatiDatotekuZaPotpisUZ(dokument, datoteka, dokdatVrsta, customtext, vrstaCert) {
		return $.dsDirectCall({
            method: "DohvatiDatotekuZaPotpisUZ",
            params: [dokument, datoteka, dokdatVrsta, customtext, vrstaCert]
        });
	}

	function DohvatiIPotpisiDatotekuSoft(dokument, datoteka, dokdatVrsta, customtext, vrstaCert, obj, errorOverride) {
		return $.dsDirectCallPost({
            method: "DohvatiIPotpisiDatotekuSoft",
			controller: "DokPotpisS",
            params: [dokument, datoteka, dokdatVrsta, customtext, vrstaCert],
			data: [ obj ],
			fail: function (error, textStatus, jqXHR, logicalError){
				if (errorOverride){
					jqXHR.statusText = "errorOverride";
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
        });
	}

	function GetDokumentiFields(tablica, potpisVerzija, paramKoji, dgrupa, dodParams) {
  		if (tablica == undefined) tablica = '';
  		if (potpisVerzija == undefined) potpisVerzija = 0;
  		if (paramKoji == undefined) paramKoji = '';
  		if (dgrupa == undefined) dgrupa = 0;
		if (!isset(dodParams))
			var dodParams = '';
		return $.dsDirectCall({
            params: [tablica, potpisVerzija, paramKoji, dgrupa, dgrupa],
            method: "uz/GetDokumentiFields?"+dodParams
        });
	}

	function GetDokumentiTemplateFields(params) {
		if (!isset(params))
			var params = '';

		return $.dsDirectCall({
            method: "uz/GetDokumentiTemplateFields?"+params
        });
	}

	function GetDokPotpisSFields() {
		return $.dsDirectCall({ //ovo treba pretvoriti u async!! - Davor
            method: "uz/GetDokPotpisSFields"
        });
	}

	function DokPotpisSObrisi(params) {
		return $.dsDirectCall({
            method: "uz/DokPotpisSObrisi/",
            params: [params]
        });
	}

	function PosaljiMailZaPotpis(dokument) {
		return $.dsDirectCall({
            method: "uz/PosaljiMailZaPotpis/",
            params: [dokument]
        });
	}

	function DokPotpisObrisi(kojiMethods, dokpotpis, dokument) {
  		if (kojiMethods == '') kojiMethods = 'uz';
		return $.dsDirectCall({
            method: kojiMethods + "/DokPotpisObrisi/",
            params: [dokpotpis, dokument]
        });
	}

	function DokPotpisArhiviraj(kojiMethods, dokpotpis, dokument) {
  		if (kojiMethods == '') kojiMethods = 'uz';
		return $.dsDirectCall({
            method: kojiMethods + "/DokPotpisArhiviraj/",
            params: [dokpotpis, dokument]
        });
	}

	function UpisiHodogramUDigitalnu(dokument) {
		return $.dsDirectCall({
            method: "uz/UpisiHodogramUDigitalnu/",
            params: [dokument]
        });
	}

	function DokPotpisSPonisti(kojiMethods, params, dokument) {
  		if (kojiMethods == '') kojiMethods = 'uz';
		return $.dsDirectCall({
	        method: kojiMethods + "/DokPotpisSPonisti/",
	        params: [params, dokument]
	    });
	}

	function DokumentObrisi(params) {
		return $.dsDirectCall({
			method: "uz/DokumentObrisi",
			params: [params]
		});
	}

	function UstrojById(ustroj, ignorirajPrava){
		if (ignorirajPrava == undefined) ignorirajPrava = false;
		return $.dsDirectCall({
			method: "uz/UstrojById",
			params: [ustroj, ignorirajPrava]
		});
	}

	function PreuzmiPredmet(predmet){
	    return $.dsDirectCall({
	        method: "uz/PreuzmiPredmet",
	        params: [predmet]
	    });
	}

	function ObradiSurjesavanje(predmett, kojaradnja){
	    return $.dsDirectCall({
	        method: "uz/ObradiSurjesavanje",
	        params: [predmett, kojaradnja]
	    });
	}

	function ObradiSurjesavanjePismena(pismenot, kojaradnja){
	    return $.dsDirectCall({
	        method: "uz/ObradiSurjesavanjePismena",
	        params: [pismenot, kojaradnja]
	    });
	}

	function ObradiParaf(pismenot, kojaradnja){
	    return $.dsDirectCall({
	        method: "uz/ObradiParaf",
	        params: [pismenot, kojaradnja]
	    });
	}

	function GetUstrojZaPartnera(partner, predloziAkoNema){
		return $.dsDirectCall({
			method: "uz/GetUstrojZaPartnera",
			params: [ partner, predloziAkoNema ]
		});
	}

	function PismenaZaPredmetFields(){
		return $.dsDirectCall({
			method: "uz/PismenaZaPredmetFields"
		});
	}

	function PredmetTZaPredmetFields(vrstaPrikaza){
		if (vrstaPrikaza == undefined) vrstaPrikaza = 0;
		return $.dsDirectCall({
			method: "uz/PredmetTZaPredmetFields",
  			params: [ vrstaPrikaza ]
		});
	}

	function DatotekePismenaPredmetaFields(){
		return $.dsDirectCall({
			method: "uz/DatotekePismenaPredmetaFields"
		});
	}

	function PriloziZaPredmetFields(){
		return $.dsDirectCall({
			method: "uz/PriloziZaPredmetFields"
		});
	}


	function GetPismenoTemplate(pismeno){
		return $.dsDirectCall({
			method: "uz/GetPismenoTemplate",
			params: [ pismeno ]
		});
	}

  	function PismenoObrisi(pismeno){
  		return $.dsDirectCall({
  			method: "uz/PismenoObrisi",
  			params: [ pismeno ]
  		});
  	}

  	function PonistiSlanjePismena(pismeno){
  		return $.dsDirectCall({
  			method: "uz/PonistiSlanjePismena",
  			params: [ pismeno ]
  		});
  	}

  	function PreuzmiPismeno(pismeno, naDokumMjPredmeta){
  		if (naDokumMjPredmeta == undefined) naDokumMjPredmeta = false;
  		return $.dsDirectCall({
  			method: "uz/PreuzmiPismeno",
  			params: [ pismeno, naDokumMjPredmeta ]
  		});
  	}

  	function PredmetObrisi(predmet){
  		return $.dsDirectCall({
  			method: "uz/PredmetObrisi",
  			params: [ predmet ]
  		});
  	}

  	function GetSljedeciBrojPismena(predmet){
  		return $.dsDirectCall({
  			method: "uz/GetSljedeciBrojPismena",
  			params: [ predmet ]
  		});
  	}

  	function PredmetById(predmet){
  		return $.dsDirectCall({
  			method: "uz/PredmetById",
  			params: [ predmet ]
  		});
  	}

  	function GetDostavnicaSFields(tip){
  		if (tip == undefined) tip='';
  		return $.dsDirectCall({
  			method: "uz/GetDostavnicaSFields",
  			params: [ tip ]
  		});
  	}

  	function FormirajDostavnicuZaDostavnicuS(dostavnicaS){
  		return $.dsDirectCall({
  			method: "uz/FormirajDostavnicuZaDostavnicuS",
  			params: [ dostavnicaS ]
  		});
  	}

  	function SetBrojKuverte(dostavnicaS, brojKuverte){  //za DostavnicaS
  		return $.dsDirectCall({
  			method: "uz/SetBrojKuverte",
  			params: [ dostavnicaS, brojKuverte ]
  		});
  	}

  	function DostavnicaObrisi(dostavnica){
  		return $.dsDirectCall({
  			method: "uz/DostavnicaObrisi",
  			params: [ dostavnica ]
  		});
  	}

  	function DostavnicaUOtpremu(dostavnica){
  		return $.dsDirectCall({
  			method: "uz/DostavnicaUOtpremu",
  			params: [ dostavnica ]
  		});
  	}

  	function DostavniceSObrisi(dostavniceS){ //parametar = objekt koji sadrzi array Dostanice
  		return $.dsDirectCall({
  			method: "uz/DostavniceSObrisi",
  			params: [ dostavniceS ]
  		});
  	}

  	function DatotekeZaDokumentFields(){
  		return $.dsDirectCall({
  			method: "uz/DatotekeZaDokumentFields"
  		});
  	}

  	function DodajPostojecuDatoteku(dokument, datoteka){
  		return $.dsDirectCall({
  			method: "uz/DodajPostojecuDatoteku",
  			params: [ dokument, datoteka ]
  		});
  	}

  	function DokDatObrisi(dokDat){
  		return $.dsDirectCall({
  			method: "uz/DokDatObrisi",
  			params: [ dokDat ]
  		});
  	}

  	function DatotekaObrisi(datoteka, dokumentID, postaviObrisana){
  		return $.dsDirectCall({
  			method: "uz/DatotekaObrisi",
  			params: [ datoteka, dokumentID, postaviObrisana ]
  		});
  	}

  	function PonistiSlanjePredmeta(predmet){
  		return $.dsDirectCall({
  			method: "uz/PonistiSlanjePredmeta",
  			params: [ predmet ]
  		});
  	}

  	function PismenaKojaSeSalju(predmet, ustroj){
  		return $.dsDirectCall({
  			method: "uz/PismenaKojaSeSalju",
  			params: [ predmet, ustroj ]
  		});
  	}

  	function PismenaNaDrugomDokumMj(predmet){ // i koja nisu kod nas a u slanju su nekamo
  		return $.dsDirectCall({
  			method: "uz/PismenaNaDrugomDokumMj",
  			params: [ predmet ]
  		});
  	}

  	function DokPotShsZaIspravak(dokpotsh, organ, mtroska){
  		if (organ == undefined) organ = '';
  		if (mtroska == undefined) mtroska = '';
  		return $.dsDirectCall({
  			method: "uz/DokPotShsZaIspravak",
  			params: [ dokpotsh, organ, mtroska ]
  		});
  	}

  	function DokumentObrisiVezu(kojiMethods, dokument, tablica, veza){
  		if (kojiMethods == '') kojiMethods = 'uz';
  		if (tablica == undefined) tablica = '';
  		if (tablica == undefined) veza = '';
  		return $.dsDirectCall({
  			method: kojiMethods + "/DokumentObrisiVezu",
  			params: [ dokument, tablica, veza ]
  		});
  	}

  	function DokumentObrisiVezuIDokument(kojiMethods, dokument, tablica, veza){
  		if (kojiMethods == '') kojiMethods = 'uz';
  		if (tablica == undefined) tablica = '';
  		if (tablica == undefined) veza = '';
  		return $.dsDirectCall({
  			method: kojiMethods + "/DokumentObrisiVezuIDokument",
  			params: [ dokument, tablica, veza ]
  		});
  	}

  	function ObrisiVezuDostavnicaSNaDokument(dostavnicas, dokument){
  		return $.dsDirectCall({
  			method: "uz/ObrisiVezuDostavnicaSNaDokument",
  			params: [ dostavnicas, dokument ]
  		});
  	}

  	function GetPravoNaDokument(dokument){
  		return $.dsDirectCall({
  			method: "uz/GetPravoNaDokument",
  			params: [ dokument ]
  		});
  	}

  	function DokumentUpisiVezu(kojiMethods, dokument, tablica, veza){
  		if (kojiMethods == '') kojiMethods = 'uz';
  		if (tablica == undefined) tablica = '';
  		if (tablica == undefined) veza = '';
  		return $.dsDirectCall({
  			method: kojiMethods + "/DokumentUpisiVezu",
  			params: [ dokument, tablica, veza ]
  		});
  	}

  	function GetKlasaPlanInfo(klasa,knjiga,godina){
  		return $.dsDirectCall({
  			method: "uz/GetKlasaPlanInfo",
  			params: [ klasa, knjiga, godina ]
  		});
  	}

  	function PismenoNovo(knjiga, ui){
  		return $.dsDirectCall({
  			method: "uz/PismenoNovo",
  			params: [ knjiga, ui ]
  		});
  	}

  	function KlasaPlanByOznaka(oznaka){
  		return $.dsDirectCall({
  			method: "uz/KlasaPlanByOznaka",
  			params: [ oznaka ]
  		});
  	}

  	function DokumentById(dokument){
  		return $.dsDirectCall({
  			method: "uz/DokumentById",
  			params: [ dokument ]
  		});
  	}

  	function GetDokDatZakljucanDo(dokument){
  		return $.dsDirectCall({
  			method: "uz/GetDokDatZakljucanDo",
  			params: [ dokument ]
  		});
  	}

  	function DGrupaById(dGrupa, ignorirajPrava){
  		if (ignorirajPrava == undefined) ignorirajPrava = false;
  		return $.dsDirectCall({
  			method: "uz/DGrupaById",
  			params: [ dGrupa, ignorirajPrava ]
  		});
  	}

  	function KlasaPlanById(klasaPlan, ignorirajPrava){
  		if (ignorirajPrava == undefined) ignorirajPrava = false;
  		return $.dsDirectCall({
  			method: "uz/KlasaPlanById",
  			params: [ klasaPlan, ignorirajPrava ]
  		});
  	}

  	function ZUpravneStvariById(zupravnastvar){
  		return $.dsDirectCall({
  			method: "uz/ZUpravneStvariById",
  			params: [ zupravnastvar ]
  		});
  	}

  	function NadleznostDeaktiviraj(nadleznost){
  		return $.dsDirectCall({
  			method: "uz/NadleznostDeaktiviraj",
  			params: [ nadleznost ]
  		});
  	}

  	function NadleznostEmailOIntDostavi(nadleznost){
  		return $.dsDirectCall({
  			method: "uz/NadleznostEmailOIntDostavi",
  			params: [ nadleznost ]
  		});
  	}

  	function GetUrBrojZaPodnesak(predmet, pismenoUstroj, partner, godina){
  		return $.dsDirectCall({
  			method: "uz/GetUrBrojZaPodnesak",
  			params: [ predmet, pismenoUstroj, partner, godina ]
  		});
  	}

  	function GetUrBrojZaAkt(predmet, ustroj, godina){
  		return $.dsDirectCall({
  			method: "uz/GetUrBrojZaAkt",
  			params: [ predmet, ustroj, godina ]
  		});
  	}

	function ProvjeriDokumentDuplo(kojiParam, naziv, dokument, partner, iznos, datumDospijeca){
		return $.dsDirectCall({
			method: "uz/ProvjeriDokumentDuplo",
			params: [ kojiParam, naziv, dokument, partner, iznos, datumDospijeca ]
		});
	}

	function GetDatotekaNaziv(datoteka){
		return $.dsDirectCall({
			method: "uz/GetDatotekaNaziv",
			params: [ datoteka ]
		});
	}

	function GetDatotekeDokumentaLista(dokument, param){
		return $.dsDirectCall({
			method: "uz/GetDatotekeDokumentaLista",
			params: [ dokument, param ]
		});
	}

	function DodajNovuDatoteku(forma, dokument){
		return $.dsDirectCall({
			method: "uz/DodajNovuDatoteku",
			params: [ forma, dokument ]
		});
	}

	function DatotekaRename(datotekaId, naziv, potpisUDat){
		return $.dsDirectCall({
			method: "uz/DatotekaRename",
			params: [ datotekaId, naziv, potpisUDat ]
		});
	}

	function VrstaPismenaObrisi(vrstaPismenaId){
		return $.dsDirectCall({
			method: "uz/VrstaPismenaObrisi",
			params: [ vrstaPismenaId ]
		});
	}

	function PismenoObradiBarkod(barkod){
		return $.dsDirectCall({
			method: "uz/PismenoObradiBarkod",
			params: [ barkod ]
		});
	}

	function SetDostavnicaSDatumPovratnice(dostavnicaS, datumP){
  		return $.dsDirectCall({
  			method: "uz/SetDostavnicaSDatumPovratnice",
  			params: [ dostavnicaS, datumP ]
  		});
	}

	function VrDostaveRazlogNeotvaranja(vrDostaveId){
  		return $.dsDirectCall({
  			method: "uz/VrDostaveRazlogNeotvaranja",
  			params: [ vrDostaveId ]
  		});
	}

	function VrDostavePosiljkaSPovratnicom(vrDostaveId){
  		return $.dsDirectCall({
  			method: "uz/VrDostavePosiljkaSPovratnicom",
  			params: [ vrDostaveId ]
  		});
	}

	function BrojDatotekaZaDokument(dokument){
		return $.dsDirectCall({
			method: "uz/BrojDatotekaZaDokument",
			params: [ dokument ]
		});
	}
	function PredmetJeBioUSlanju(predmet){
		return $.dsDirectCall({
			method: "uz/PredmetJeBioUSlanju",
			params: [ predmet ]
		});
	}

	function PostaviDokDatZadan(dokdat, zadan) {
		return $.dsDirectCall({
            method: "uz/PostaviDokDatZadan",
            params: [ dokdat, zadan ]
        });
	}

	function PostaviPotpisUDatoteci(datoteka, PotpisUDatoteci) {
		return $.dsDirectCall({
            method: "uz/PostaviPotpisUDatoteci",
            params: [ datoteka, PotpisUDatoteci ]
        });
	}

	function PostaviDokDatPonisteno(dokdat, Ponisteno) {
		return $.dsDirectCall({
            method: "uz/PostaviDokDatPonisteno",
            params: [ dokdat, Ponisteno ]
        });
	}

	function DokumentMakniSNepovezanih(dokument, upisiVezuNaSamogSebe) {
		return $.dsDirectCall({
            method: "uz/DokumentMakniSNepovezanih",
            params: [ dokument, upisiVezuNaSamogSebe ]
        });
	}

	function DokumentImaVezuNaSamogSebe(dokument, tablica, veza) {
		return $.dsDirectCall({
            method: "uz/DokumentImaVezuNaSamogSebe",
            params: [ dokument, tablica, veza ]
        });
	}

	function DohvatiDatotekuBase64(datoteka, dokument){
		return $.dsDirectCall({
            method: "uz/DohvatiDatotekuBase64",
            params: [ datoteka, dokument ]
        });
	}

	function DohvatiDokPotShZaDGrupaKlasaPlan(dokument, dgrupa, klasaplan, organ, mtroska) {
		return $.dsDirectCall({
            method: "uz/DohvatiDokPotShZaDGrupaKlasaPlan",
            params: [dokument, dgrupa, klasaplan, organ, mtroska]
        });
	}

  	function GenPotpisnikePremaShemi(kojiMethods, dokument, dokpotsh){
  		if (kojiMethods == '') kojiMethods = 'uz';
  		return $.dsDirectCall({
  			method: kojiMethods + "/GenPotpisnikePremaShemi",
  			params: [ dokument, dokpotsh ]
  		});
  	}

  	function DajSveGrupeKorZaUz(dajSveGrupe){
  		return $.dsDirectCall({
  			method: "uz/DajSveGrupeKorZaUz",
  			params: [ dajSveGrupe ]
  		});
  	}

  	function DeaktivirajDGrupaKor(arrayDGrupaKor){
  		return $.dsDirectCall({
  			method: "uz/DeaktivirajDGrupaKor",
  			params: [arrayDGrupaKor]
  		});
  	}

  	function DajPopisDGrupa(grupaKor, zOsoba){
  		return $.dsDirectCall({
  			method: "uz/DajPopisDGrupa",
  			params: [ grupaKor, zOsoba ]
  		});
  	}

    function DajPopisKorisnikaIliGrupa(grupaKor, korisnik){
  		return $.dsDirectCall({
  			method: "uz/DajPopisKorisnikaIliGrupa",
  			params: [ grupaKor, korisnik ]
  		});
  	}

	function DajTextLabeleZaSkupnoPotpisivanje(dokumentLista){
		return $.dsDirectCall({
			method: "uz/DajTextLabeleZaSkupnoPotpisivanje",
			params: [ dokumentLista ]
		});
	}

  	function DokPotpisById(dokpotpis){
  		return $.dsDirectCall({
  			method: "uz/DokPotpisById",
  			params: [ dokpotpis ]
  		});
  	}

	function DajDokPotpisZaDokument(dokument, lbSamoAktualni){
		if (lbSamoAktualni == undefined) lbSamoAktualni = true;
  		return $.dsDirectCall({
  			method: "uz/DajDokPotpisZaDokument",
  			params: [ dokument, lbSamoAktualni ]
  		});
  	}

	function PredmetInfo(predmet){
		return $.dsDirectCall({
			method: "uz/PredmetInfo",
			params: [ predmet ]
		});
	}

	function PismenoInfo(pismeno){
		return $.dsDirectCall({
			method: "uz/PismenoInfo",
			params: [ pismeno ]
		});
	}

	function DokumentInfo(dokument){
		return $.dsDirectCall({
			method: "uz/DokumentInfo",
			params: [ dokument ]
		});
	}

	function UpisiDokumentUVanjskuPisarnicu(dokument){
		return $.dsDirectCall({
			method: "uz/UpisiDokumentUVanjskuPisarnicu",
			params: [ dokument ]
		});
	}

	function DokumentMoguceBrisanje(dokumentID){
		return $.dsDirectCall({
			method: "uz/DokumentMoguceBrisanje",
			params: [ dokumentID ]
		});
	}

	function DokumentObradiBarkod(barkod){
		return $.dsDirectCall({
			method: "uz/DokumentObradiBarkod",
			params: [ barkod ]
		});
	}

	function PostaviDokumentStatus(dokument, status, potpisivanje) {
		if (potpisivanje == undefined) potpisivanje = 0;
		return $.dsDirectCall({
            method: "uz/PostaviDokumentStatus/",
            params: [dokument, status, potpisivanje]
        });
	}
	
	function PostaviDokumentERacunStatus(dokument, status, razlogOdbijanja, pogresnaPoslovnaJedinica) {		
		return $.dsDirectCall({
            method: "uz/PostaviDokumentERacunStatus",
            params: [dokument, status, razlogOdbijanja, pogresnaPoslovnaJedinica]
        });
	}

	function ProvjeriDokumentZaIspravak(dokument){
		return $.dsDirectCall({
			method: "uz/ProvjeriDokumentZaIspravak",
			params: [ dokument ]
		});
	}

	function GetSveDokPotSh(dokument, dgrupa, organ, mtroska, sveSheme, saUnosa){
		return $.dsDirectCall({
			method: "uz/GetSveDokPotSh",
			params: [ dokument, dgrupa, organ, mtroska, sveSheme, saUnosa ]
		});
	}

	function VrNamjenaObrisi(vrnamjena) {
		return $.dsDirectCall({
            method: "uz/VrNamjenaObrisi/",
            params: [vrnamjena]
        });
	}

	function DostavnicaSObrisi(params) {
		return $.dsDirectCall({
			method: "uz/DostavnicaSObrisi",
			params: [params]
		});
	}

	function SluzbenaObrisi(params) {
		return $.dsDirectCall({
			method: "uz/SluzbenaObrisi",
			params: [params]
		});
	}

	function DostavnicaSRenumerirajStavke(dostavnica, stavka){
		return $.dsDirectCall({
			method: "DostavnicaSRenumerirajStavke",
			params: [ dostavnica, stavka ]
		});
	}

	function DatotekuPovratniceDodatiUAkt(pismeno, dokumentizvor){
		return $.dsDirectCall({
			method: "DatotekuPovratniceDodatiUAkt",
			params: [ pismeno, dokumentizvor, ]
		});
	}

	function DostavnicaSRenumerirajKuvertu(dostavnica, kuverta){
		return $.dsDirectCall({
			method: "DostavnicaSRenumerirajKuvertu",
			params: [ dostavnica, kuverta ]
		});
	}

  	function DodajUPostojecuDostavnicu(dostavnicas, dostavnica){
  		return $.dsDirectCall({
  			method: "uz/DodajUPostojecuDostavnicu",
  			params: [ dostavnicas, dostavnica ]
  		});
  	}

	function DostavnicaSGenerirajPismeno(dostavnica, internoDostavi){
		return $.dsDirectCall({
			method: "DostavnicaSGenerirajPismeno",
			params: [ dostavnica, internoDostavi ]
		});
	}	

	function AzurirajDatotekeZaDokument(datotekeData, zaDokument, errorOverride){
		return $.dsDirectCallPost({
			method: "AzurirajDatotekeZaDokument",
			controller: "dokument",
			data: [datotekeData ],
			params: [ zaDokument ],
			fail: function (error, textStatus, jqXHR, logicalError){
				if (errorOverride){
					jqXHR.statusText = "errorOverride";
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});
	}

    function PostojiHodogramZaDokument(dokument){
        return $.dsDirectCall({
            method: "uz/PostojiHodogramZaDokument",
            params: [ dokument ]
        });
    }

    function PostojePotpisniciZaDokument(dokument){
        return $.dsDirectCall({
            method: "uz/PostojiHodogramZaDokument",
            params: [ dokument ]
        });
    }
    function SluzbenaZaPredmetFields(){
  		return $.dsDirectCall({
  			method: "uz/GetSluzbenaFields",
  			params: [ 1, 0, 0 ]
  		});
  	}

	function UstrojParObrisi(partner) {
		return $.dsDirectCall({
            method: "uz/UstrojParObrisi/",
            params: [partner]
        });
	}

	function DostavnicaSEmailInfo(dostavnicas){
		return $.dsDirectCall({
			method: "uz/DostavnicaSEmailInfo",
			params: [ dostavnicas ]
		});
	}

	function GetPredmetParLista(predmet, param){
		return $.dsDirectCall({
			method: "uz/GetPredmetParLista",
			params: [ predmet, param ]
		});
	}

	function GetPredmetParFields(liPredmet){
	    return $.dsDirectCall({
	        method: "GetPredmetParFields",
			params: [liPredmet]
	    });
    }

	function PartnerUzById(partner, ukdodano){
		return $.dsDirectCall({
			method: "uz/PartnerUzById",
			params: [partner, ukdodano]
		});
	}

    function ZPostupakArhZaPredmetFields(predmet){
        return $.dsDirectCall({
            method: "uz/ZPostupakArhZaPredmetFields",
            params: [ predmet ]
        });
    }

    function ZupItPosaljiPredmet(objekt, predmet, zPostupak){
        return $.dsDirectCall({
            method: "uz/ZPosalji",
            params: [ objekt, predmet, zPostupak ]
        });
    }

    function ZupItDohvatiJavnopravnaTijela(){
        return $.dsDirectCall({
            method: "uz/ZDohvatiJavnopravnaTijela",
            params: [  ]
        });
    }

    function ZupItDohvatiUpravneStvari(){
        return $.dsDirectCall({
            method: "uz/ZupItDohvatiUpravneStvari",
            params: [  ]
        });
    }
    
    function ZupItDohvatiStatuse(){
        return $.dsDirectCall({
            method: "uz/ZupItDohvatiStatuse",
            params: [  ]
        });
    }

    function PrKnjigaById(prKnjiga){
        return $.dsDirectCall({
            method: "uz/PrKnjigaById",
            params: [ prKnjiga ]
        });
    }
    
    function PregledOcr(datoteka){
        return $.dsDirectCall({
            method: "uz/PregledOcr",
            params: [ datoteka ]
        });
    }

    function PrepoznajOcr(datoteka, uPozadini){
        return $.dsDirectCall({
            method: "uz/PrepoznajOcr",
            params: [ datoteka, uPozadini ]
        });
    }

    function PonistiOznakuZaOCR(datoteka){
        return $.dsDirectCall({
            method: "uz/PonistiOznakuZaOCR",
            params: [ datoteka ]
        });
    }

    function ZOsobaZupItNoviKorisnikLozinka(zOsoba, akcija){
        return $.dsDirectCall({
            method: "uz/ZOsobaZupItNoviKorisnikLozinka",
            params: [   zOsoba, akcija ]
        });        
    }

	function GetDokumentPravoNa(radnja, dokument){
		return $.dsDirectCall({
			method: "uz/GetDokumentPravoNa",
			params: [ radnja, dokument ]
		});
	}

	function DozvoliPrikazDatotekeSCert(datoteka, dokument){
		return $.dsDirectCall({
			method: "uz/DozvoliPrikazDatotekeSCert",
			params: [ datoteka, dokument ]
		});
	}
	
	function DohvatiDatotekuIdPrvuZadnju(dokument, koju){
		return $.dsDirectCall({
			method: "uz/DohvatiDatotekuIdPrvuZadnju",
			params: [ dokument, koju ]
		});
	}
	

} (konto.uz.api = {}));